<div class="wrapper" (click)="copyValue()">
  <div class="value">{{ copied ? 'Link copied!' : orgUrl }}</div>
  <app-shared-button size="small">Copy</app-shared-button>
</div>
